export const SET_LOGIN_LOADING = "site/SET_LOGIN_LOADING";

export const SET_USER_DETAIL = "site/SET_USER_DETAIL";

export const SET_ALL_PROPERTY = "site/SET_ALL_PROPERTY";
export const SET_PROPERTY = "site/SET_PROPERTY";

export const SET_ALL_SPACE = "site/SET_ALL_SPACE";
export const SET_SPACE = "site/SET_SPACE";

export const SET_PROFILE = "site/SET_PROFILE";
export const SET_MY_BOOKING = "site/SET_MY_BOOKING";